export const paths = ['/permission-groups'];
